import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import enUS from '../assets/langs/en-US.json'

export const langs = [
  {
    key: 'en-US',
    title: 'English',
    translation: enUS,
  },
]

export function initI18n() {
  i18n
    .use(initReactI18next)
    .init({
      resources: langs.reduce((acc, { key, translation }) => {
        acc[key] = {
          translation,
        }

        return acc
      }, {} as Record<string, {
        translation: object
      }>),
      lng: langs[0].key,
      fallbackLng: langs[0].key,
      interpolation: {
        escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
      },
    })
}
